import commonUtil from '../../../../../utils/commonUtil';

export const CONTRACT_PAGE_LOAD = 'CONTRACT_PAGE_LOAD';
export const CONTRACT_PAGE_LOAD_SUCCESS = 'CONTRACT_PAGE_LOAD_SUCCESS';
export const CONTRACT_PAGE_LOAD_FAIL = 'CONTRACT_PAGE_LOAD_FAIL';

const CONTRACTDETAILSURL = '/api/EditEvent/ContractDetails';

export function handleGetEventContractPage(eventId,eventType,eventDate) {
  const payload = {};
  payload.brand = commonUtil.getBrand();
  payload.channel = commonUtil.getChannel();
  payload.eventId = eventId;
  payload.eventType = eventType;
  if(eventDate){
    payload.eventDate = eventDate;
  }
  
  return {
    types: [CONTRACT_PAGE_LOAD, CONTRACT_PAGE_LOAD_SUCCESS, CONTRACT_PAGE_LOAD_FAIL],
    promise: client => client.post(CONTRACTDETAILSURL, { data: payload }), // params not used, just shown as demonstration
  };
}
